import script from "./DocumentRow.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentRow.vue?vue&type=script&setup=true&lang=js"

import "./DocumentRow.vue?vue&type=style&index=0&id=9d7587ce&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d7587ce"]])

export default __exports__